module.exports = __webpack_public_path__ + "static/media/sellanizer_logo.37962fc5.png";